import { ReactNode } from 'react'

import { useTheme } from 'styled-components'

interface IProps {
  children: ReactNode
  isInvalid?: boolean
  isRequired?: boolean
}

export function FormLabel({ children, isInvalid, isRequired = false }: IProps) {
  const { colors } = useTheme()

  const textColor = isInvalid ? colors.textError : colors.text

  return (
    <label style={{ color: textColor, fontSize: 14, fontWeight: 500, display: 'flex', gap: 3 }}>
      {children}
      {isRequired && <span style={{ color: colors.textError }}>*</span>}
    </label>
  )
}
